var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToManage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "91px",
    viewBox: "0 0 91 91",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.53851 0 5.80652 1.09378 5.97982 2.50291L6 2.83333L6 65.1667C6 66.7315 4.65685 68 3 68C1.46149 68 0.193479 66.9062 0.0201832 65.4971L0 65.1667L0 2.83333C0 1.26853 1.34315 0 3 0Z",
    transform: "translate(42 11)",
    id: "Path-6-Copy",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.53851 0 5.80652 1.09378 5.97982 2.50291L6 2.83333L6 65.1667C6 66.7315 4.65685 68 3 68C1.46149 68 0.193479 66.9062 0.0201832 65.4971L0 65.1667L0 2.83333C0 1.26853 1.34315 0 3 0Z",
    transform: "translate(22 11)",
    id: "Path-6",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 56.6667C4.53851 56.6667 5.80652 57.7604 5.97982 59.1696L6 59.5L6 65.1667C6 66.7315 4.65685 68 3 68C1.46149 68 0.193479 66.9062 0.0201832 65.4971L0 65.1667L0 59.5C0 57.9352 1.34315 56.6667 3 56.6667ZM3 0C4.53851 0 5.80652 1.09378 5.97982 2.50291L6 2.83333L6 36.8333C6 38.3981 4.65685 39.6667 3 39.6667C1.46149 39.6667 0.193479 38.5729 0.0201832 37.1638L0 36.8333L0 2.83333C0 1.26853 1.34315 0 3 0Z",
    transform: "translate(62 11)",
    id: "Shape",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0Z",
    transform: "translate(17 17)",
    id: "Oval",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0Z",
    transform: "translate(36 56)",
    id: "Oval-Copy-2",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0Z",
    transform: "translate(56 17)",
    id: "Oval-Copy",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "translate(62 56)",
    id: "Oval",
    fill: "#07A5DF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.65685 0 6 1.34315 6 3C6 4.65685 4.65685 6 3 6C1.34315 6 0 4.65685 0 3C0 1.34315 1.34315 0 3 0Z",
    transform: "translate(42 62)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.65685 0 6 1.34315 6 3C6 4.65685 4.65685 6 3 6C1.34315 6 0 4.65685 0 3C0 1.34315 1.34315 0 3 0Z",
    transform: "translate(62 22)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.65685 0 6 1.34315 6 3C6 4.65685 4.65685 6 3 6C1.34315 6 0 4.65685 0 3C0 1.34315 1.34315 0 3 0Z",
    transform: "translate(22 22)",
    id: "Path",
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 0L90 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToManage);
export default __webpack_public_path__ + "static/media/toManage.877e5d6b35424bd281b46ef20c176ed0.svg";
export { ForwardRef as ReactComponent };